export default class PatchOrganizationRequest {
  Id: string = "";
  Status: number | undefined;
  StatusComments: string = "";
  MergeId: string | undefined;
}
